import Select from 'react-select'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import BackButton from '../../../elements/BackButton'
import moment from 'moment'
import { getTeacherSchoolData } from '../../../redux/Teacher/user/action'
import { addStudentAttendence } from '../../../redux/Teacher/student/action'

export class Attendence extends Component {
    state = {
        sections: [],
        class_id: '',
        section_id: '',
        date: moment().format('YYYY-MM-DD'),
        loading: false,
    }

    componentDidMount() {
        const { teacher } = this.props;
        if (teacher?.data?.auth_token) {
            this.props.getTeacherSchoolData(teacher.data.auth_token);
        }
    }

    getSections = (val) => {
        const { schooldata } = this.props;
        this.setState({ class_id: val });
        const sections = schooldata?.data?.student_classes
            ?.find((data) => data.id == val)
            ?.sections?.map((section) => ({
                value: section.id,
                label: section.name,
            }));
        this.setState({ sections: sections });
    };

    handleSubmit = (e) => {
        e.preventDefault();
        const { teacher } = this.props;
        const { date, section_id, class_id } = this.state;
        const formattedDate = date ? date : moment().format("YYYY-MM-DD");

        this.setState({ loading: true });
        this.props.addStudentAttendence(
            teacher?.data?.auth_token,
            teacher?.data?.staff?.user_id,
            formattedDate,
            null,
            section_id,
            class_id
        ).then(() => {
            this.setState({ loading: false });
            this.props.history.push('/view-teacher-attendence');
        }).catch(() => {
            this.setState({ loading: false });
        });
    };

    render() {
        const { schooldata } = this.props;
        const { sections, date } = this.state;
        const classes = schooldata?.data?.student_classes?.map((data) => ({
            value: data.id,
            label: data.name,
        }));

        return (
            <React.Fragment>
                <BackButton title={"Attendence"} />
                <form onSubmit={this.handleSubmit}>
                    <div className='px-3 mt-4'>
                        <div className="mt-3">
                            <Select
                                className="text-muted attendence-input px-2"
                                placeholder='Class'
                                styles={customStyles}
                                options={classes}
                                onChange={(e) => {
                                    let value = e.value;
                                    this.setState({ class_id: value });
                                    this.getSections(value);
                                }}
                            />
                        </div>

                        <div className="mt-3">
                            <Select
                                className="text-muted attendence-input px-2"
                                placeholder='Section'
                                styles={customStyles}
                                options={sections}
                                onChange={(e) => {
                                    let value = e.value;
                                    this.setState({ section_id: value });
                                }}
                            />
                        </div>
                        <div className="mt-3">
                            <label className='px-2 text-muted'>Date</label>
                            <input
                                type="date"
                                className="text-muted attendence-input px-3"
                                style={{ fontSize: '13px' }}
                                value={date}
                                placeholder='On date'
                                onChange={(e) => {
                                    let value = e.target.value;
                                    this.setState({ date: value });
                                }}
                                required
                            />
                        </div>
                    </div>
                    <div className='position-fixed bottom-0 py-2 w-100 px-3'>
                        <button type="submit" className='btn attendence-dwld-btn mt-2 py-3 w-100' disabled={this.state.loading}>
                            {this.state.loading ? 'Fetching...' : 'Get'}
                        </button>
                    </div>
                </form>
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state) => ({
    teacher: state.teacher.teacher,
    schooldata: state.teacher.schooldata,
})

export default connect(mapStateToProps, {
    getTeacherSchoolData,
    addStudentAttendence,
})(Attendence)

const customStyles = {
    option: (provided, state) => ({
        ...provided,
        backgroundColor: '#fff',
        border: 'none', // tried border: 'none'
        boxShadow: 'none', // tried border: 'none'
        outline: 'none',

    }),
    control: (provided) => ({
        ...provided,
        height: "50px",
        width: "88vw",
        border: "none",
        boarderRadius: "10px",
        fontSize: '13px',
        borderStyle: 'none',
        background: 'rgba(190, 175, 179, 0.05)',
        outline: 'none',
        fontWeight: '400',
        lineHeight: '14px',
        letterSpacing: '1px',
        color: '#86878E',

    })
}


